import { render, staticRenderFns } from "./SalesReportExportButton.vue?vue&type=template&id=5943e970&"
import script from "./SalesReportExportButton.vue?vue&type=script&lang=ts&"
export * from "./SalesReportExportButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports